const COMPONENT_NAME = "RichTextEntry";
export {
  COMPONENT_NAME
};
